declare let CONFIG: {
  API: string;
  ENVIRONMENT: string;
  RELEASE?: string;
};

export const { API, ENVIRONMENT, RELEASE } = CONFIG;
